import { useAuth } from "@/context/AuthContext";
import { useTheme } from "@/context/ThemeContext";

export function Logo({ size = "md", light = false, pay = false }) {
  const { branding } = useAuth();
  const { theme } = useTheme();
  const dims = { sm: "h-8", md: "h-10", lg: "h-14", xl: "h-16 sm:h-20", "2xl": "h-20 sm:h-24" }[size] || "h-10";
  const isLightTheme = theme === "light";
  const url = pay
    ? (isLightTheme ? branding?.pay_logo_light_url || branding?.logo_url : branding?.logo_url)
    : (isLightTheme ? branding?.logo_light_url || branding?.logo_url : branding?.logo_url);
  if (url) {
    const src = url.startsWith("http") ? url : `${process.env.REACT_APP_BACKEND_URL}${url}`;
    return <img src={src} alt={branding?.application_name} className={`${dims} w-auto object-contain`} data-testid="brand-logo" />;
  }
  return (
    <div className={`flex items-center gap-2 ${dims}`} data-testid="brand-logo">
      <div className="relative w-8 h-8 rounded-full bg-[#FFD60A] flex items-center justify-center overflow-hidden">
        <span className="font-heading font-black text-xl text-black">S</span>
      </div>
      <span className={`font-heading font-black text-2xl tracking-tight ${light && !isLightTheme ? "text-white" : "text-black"}`}>
        {branding?.application_name || "STREAM"}
      </span>
    </div>
  );
}
